import {
    SHOW_HEAD,
    SHOW_FOOTER,
    SHOW_WAIT_BLOCK,
    STEP_WAIT_BLOCK,
    ACTIVATE_DEMO
} from '../actions/actionsStructure';
import {
    ERROR_WAIT_BLOCK
} from '../../AdminProtectora/actions/actionsAdmin';

const initialState = {
    showHead: false,
	showFooter: false,
    showWaitBlock: false,
    stepWaitBlock: 0,
    errorWaitBlock: "",
    activateDemo: false
};

export function reducerStructureControl(state = initialState, action) {
	switch (action.type) {
        case SHOW_HEAD:
            // console.log("structureControl::structureControl() -> action.type = " + action.type +" -> " + JSON.stringify( action.payload));
			return {...state, showHead: action.payload.showHead};
        case SHOW_FOOTER:
            // console.log("structureControl::structureControl() -> action.type = " + action.type +" -> " + JSON.stringify( action.payload));
            return {...state, showFooter: action.payload.showFooter};
        case SHOW_WAIT_BLOCK:
            // console.log("structureControl::structureControl() -> action.type = " + action.type +" -> " + JSON.stringify( action.payload));
            return Object.assign({}, state, {
                showWaitBlock: action.payload.showWaitBlock
            });
        case STEP_WAIT_BLOCK:
            // console.log("structureControl::structureControl() -> action.type = " + action.type +" -> " + JSON.stringify( action.payload));
            return Object.assign({}, state, {
                stepWaitBlock: action.payload.stepWaitBlock
            });
        case ERROR_WAIT_BLOCK:
            // console.log("structureControl::structureControl() -> action.type = " + action.type +" -> " + JSON.stringify( action.payload));
            return Object.assign({}, state, {
                errorWaitBlock: action.payload.errorWaitBlock
            });
        case ACTIVATE_DEMO:
            // console.log("structureControl::structureControl() -> action.type = " + action.type +" -> " + JSON.stringify( action.payload));
            return Object.assign({}, state, {
                activateDemo: action.payload.activateDemo
            });
		default:
            //console.log("structureControl::structureControl() -> action.type = " + action.type /*+" -> " + JSON.stringify( action.payload)*/);
			return state
	}
}